import { useContext, useEffect, useState } from "react";

import {
  Checkbox,
  FormControlLabel,
  Grid,
  Icon,
  Switch,
  IconButton,
  Tooltip,
} from "@material-ui/core";

import { DeleteOutlined, EditOutlined } from "@material-ui/icons";

import Btn from "../../../../components/buttons/Btn";
import Fieldset from "../../../../components/basics/Fieldset";
import SelectErp from "../../../../components/basics/SelectErp";
import SearchSelect from "../../../../components/inputs/SearchSelect";
import SearchDialog from "../../../../patterns/modals/SearchDialog";
import { GerenciamentoContratoContext } from "../contexts/GerenciamentoContratoContext";
import { GerenciamentoContratoFilterContext } from "../contexts/GerenciamentoContratoFilterContext";
import { ConfigurationContext } from "../contexts/ConfigurationContext";
import { ChipTitleStyled, DivBox } from "../styles/GerenciamentoContrato";
import useGerenciamentoContratoController from "../controllers/GerenciamentoContratoController";
import TableDefault from "../../../../components/grid/TableDefault";
import MaskService from "../../../../utils/mask/maskService";
import { ModalContasReceber } from "./ModalEdicaoContasReceber";
import { GlobalVariables } from "../../../../GlobalVariables";

import moment from "moment";
import "moment/locale/pt-br";

const AccordionInfoFaturamento = ({ location }) => {
  const {
    typePayment,
    setTypePayment,
    listTypePayment,
    generateBillet,
    setGenerateBillet,
    bank,
    setBank,
    listBank,
    typeBillet,
    setTypeBillet,
    listBillet,
    issueNfse,
    setIssueNfse,
    generateFinancialStatement,
    setGenerateFinancialStatement,
    sendByEmail,
    setSendByEmail,
    attachNfse,
    setAttachNfse,
    attachFinancialStatement,
    setAttachFinancialStatement,
    attachBillet,
    setAttachBillet,
    modality,
    formOfPayment,
    setFormOfPayment,
    listFormOfPayment,
    itensInstallments,
    disabledPaymentOptions,
    errorsSubmit,
    valueInNote,
    setValueInNote,
    issueType,
    setIssueType,
    applyBillingRule,
    setApplyBillingRule,
    billingRule,
    setBillingRule,
    financialResponsibleEnabled,
    setFinancialResponsibleEnabled,
    financialResponsibleInfos,
    setFinancialResponsibleInfos,
  } = useContext(GerenciamentoContratoContext);

  const { configuration } = useContext(ConfigurationContext);

  const { listBillingRules } = useContext(GerenciamentoContratoFilterContext);

  const {
    handleFormOfPayment,
    handleInstallmentsTable,
    removeInstallments,
    verifyIsBoletoOrTransferency,
    handleSelectFinancialResponsible,
  } = useGerenciamentoContratoController();

  const [editingCrItem, setEditingCrItem] = useState(null);
  const [openEditCrModal, setOpenEditCrModal] = useState(false);
  const [
    modalFinancialResponsibleOpen,
    setModalFinancialResponsibleOpen,
  ] = useState(false);

  const handleOpenEditCr = (item) => {
    setEditingCrItem(item);
    setOpenEditCrModal(true);
  };

  useEffect(() => {
    setTypePayment(null);
    setFormOfPayment(null);
  }, [modality, setTypePayment, setFormOfPayment]);

  useEffect(() => {
    handleFormOfPayment();
  }, [typePayment, handleFormOfPayment]);

  useEffect(() => {
    setGenerateBillet(verifyIsBoletoOrTransferency(typePayment?.label || ""));
  }, [typePayment, verifyIsBoletoOrTransferency, setGenerateBillet]);

  useEffect(() => {
    setValueInNote(issueNfse);
    setAttachNfse(sendByEmail && issueNfse);
  }, [sendByEmail, issueNfse, setValueInNote, setAttachNfse]);

  useEffect(() => {
    setAttachBillet(sendByEmail && generateBillet);
  }, [sendByEmail, generateBillet, setAttachBillet]);

  useEffect(() => {
    setAttachFinancialStatement(sendByEmail && generateFinancialStatement);
  }, [sendByEmail, generateFinancialStatement, setAttachFinancialStatement]);

  useEffect(() => {
    setIssueType(true);
  }, [typePayment, setIssueType]);

  let columns = [
    { label: "Parcela", format: (item) => item?.documentNumber },
    {
      label: "Vencimento",
      format: (item) => {
        return item?.dueDate
          ? moment(item.dueDate).format("DD/MM/YYYY")
          : "--/--/----";
      },
    },
    {
      label: "Valor",
      format: (item) =>
        `R$ ${MaskService.toMask(
          "decimal",
          item?.value.toFixed(configuration?.contract_decimal_size || 2),
          configuration?.contract_decimal_size || 2
        )}`,
    },
  ];

  // Estará desabilitado caso esteja editando
  // um contrato Recorrente ou se estiver
  // editando um contrato Avulso e o mesmo
  // esteja impossibilitado de editar a forma/tipo de pagamento.
  if (
    !disabledPaymentOptions &&
    modality?.value !== GlobalVariables.contract.modality.recurring
  )
    columns.push(
      ...[
        {
          label: "Ações",
          format: (item) => (
            <>
              <Tooltip title="Editar">
                <IconButton
                  onClick={() => handleOpenEditCr(item)}
                  bgcolor="darkred"
                >
                  <EditOutlined />
                </IconButton>
              </Tooltip>
              <Tooltip title="Remover">
                <IconButton
                  onClick={() => removeInstallments()}
                  bgcolor="darkred"
                >
                  <DeleteOutlined />
                </IconButton>
              </Tooltip>
            </>
          ),
        },
      ]
    );

  return (
    <>
      {openEditCrModal && (
        <ModalContasReceber
          open={openEditCrModal}
          setOpen={setOpenEditCrModal}
          editingItem={editingCrItem}
        />
      )}
      {modalFinancialResponsibleOpen && (
        <SearchDialog
          open={modalFinancialResponsibleOpen}
          setOpen={setModalFinancialResponsibleOpen}
          columns={[
            { label: "CPF/CNPJ", id: "cpfcnpj" },
            { label: "Nome", id: "razao" },
          ]}
          selectable={true}
          multiSelect={false}
          handleMainClick={handleSelectFinancialResponsible}
          route="prouser/clientes/v1"
          title="RESPONSÁVEL FINANCEIRO"
          where={{ ativo: "S" }}
        />
      )}
      <Fieldset
        titulo={
          <ChipTitleStyled
            label="INFORMAÇÕES PARA FATURAMENTO"
            bgcolor="lightgrey"
            textcolor="black"
          />
        }
        bgcolor="white"
        textcolor="black"
        accordion
        defaultExpanded
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={!!financialResponsibleEnabled}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setFinancialResponsibleEnabled(checked);
                    if (!checked) {
                      setFinancialResponsibleInfos(null);
                    }
                  }}
                  disabled={location?.state?.status === "C"}
                  color="primary"
                />
              }
              label="Responsável financeiro diferente do titular"
            />
          </Grid>
          {financialResponsibleEnabled && (
            <>
              <Grid item xs={12} md={5}>
                <SearchSelect
                  getOptionLabel={(option) =>
                    `${option.cpfcnpj} - ${option.razao}`
                  }
                  label="Responsável Financeiro"
                  value={financialResponsibleInfos}
                  setValue={setFinancialResponsibleInfos}
                  route="prouser/clientes/v1"
                  filter="razao,apelido"
                  where={{ ativo: "S" }}
                  variant="filled"
                  onChange={(value) => setFinancialResponsibleInfos(value)}
                  customChange
                  disabled={location?.state?.status === "C"}
                />
              </Grid>
              <Grid item xs={12} md={1}>
                <Btn
                  startIcon={<Icon>search</Icon>}
                  full="true"
                  onClick={() => setModalFinancialResponsibleOpen(true)}
                  bgcolor="tertiary"
                  disabled={location?.state?.status === "C"}
                />
              </Grid>
              <Grid item xs={12} md={6} />
            </>
          )}
          <Grid item xs={12} md={6} lg={6}>
            <SelectErp
              label="Tipo de Pagamento"
              value={typePayment}
              setValue={setTypePayment}
              optionsList={listTypePayment}
              descriptionField="label"
              disabled={
                location?.state?.id &&
                modality?.value ===
                  GlobalVariables.contract.modality.separate &&
                disabledPaymentOptions
              }
            />
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            {modality?.value === GlobalVariables.contract.modality.separate && (
              <SelectErp
                label="Forma de Pagamento"
                value={formOfPayment}
                onChange={handleInstallmentsTable}
                optionsList={listFormOfPayment}
                descriptionField="label"
                error={!!errorsSubmit?.formOfPayment}
                helperText={errorsSubmit?.formOfPayment || ""}
                disabled={!!location?.state?.id && disabledPaymentOptions}
              />
            )}
          </Grid>
          {modality?.value === GlobalVariables.contract.modality.separate && (
            <Grid item xs={12}>
              <TableDefault
                stickyHeader
                selectable={false}
                tableTitle=""
                columns={columns}
                values={itensInstallments}
                smallFont
                maxHeight="24vh"
                fullWidth
              />
            </Grid>
          )}
          <Grid item container xs={12} spacing={1}>
            <DivBox item xs={3}>
              {verifyIsBoletoOrTransferency(typePayment?.label || "") && (
                <FormControlLabel
                  control={
                    <Switch
                      checked={generateBillet}
                      onChange={({ target: { checked } }) => {
                        if (!checked && issueNfse) {
                          setIssueType(true);
                        }
                        setGenerateBillet((current) => !current);
                      }}
                      color="secondary"
                    />
                  }
                  label="Gerar Boleto"
                  labelPlacement="end"
                />
              )}
            </DivBox>
            <Grid item xs>
              {verifyIsBoletoOrTransferency(typePayment?.label || "") &&
                generateBillet && (
                  <SelectErp
                    label="Banco/Agência"
                    value={bank}
                    setValue={setBank}
                    optionsList={listBank}
                    descriptionField="label"
                    error={!!errorsSubmit?.bank}
                    helperText={errorsSubmit?.bank || ""}
                  />
                )}
            </Grid>
            <Grid item xs={3}>
              {verifyIsBoletoOrTransferency(typePayment?.label || "") &&
                generateBillet &&
                bank?.codBank === "000" && (
                  <SelectErp
                    label="Tipo de Boleto"
                    value={typeBillet}
                    setValue={setTypeBillet}
                    optionsList={listBillet}
                    descriptionField="label"
                    error={!!errorsSubmit?.typeBillet}
                    helperText={errorsSubmit?.typeBillet || ""}
                  />
                )}
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={issueNfse}
                  onChange={({ target: { checked } }) => {
                    setIssueNfse(checked);
                    if (!checked) {
                      setIssueType(false);
                    } else {
                      setIssueType(true);
                    }
                  }}
                  color="secondary"
                />
              }
              label="Emitir Nota Fiscal Serviço (NFSe)"
              labelPlacement="end"
            />
          </Grid>
          {issueNfse && (
            <Grid item style={{ marginLeft: 30 }} xs={11}>
              <FormControlLabel
                control={
                  <Switch
                    checked={issueType}
                    onChange={({ target: { checked } }) => {
                      if (!generateBillet) return setIssueType(true);
                      setIssueType((current) => !current);
                    }}
                    color="secondary"
                  />
                }
                label="Emitir no Faturamento"
                labelPlacement="end"
              />
            </Grid>
          )}
          {issueNfse && (
            <Grid item style={{ marginLeft: 30 }} xs={11}>
              <FormControlLabel
                control={
                  <Switch
                    checked={!issueType}
                    onChange={({ target: { checked } }) => {
                      setIssueType((current) => !current);
                    }}
                    color="secondary"
                  />
                }
                label="Emitir na Liquidação do Boleto"
                labelPlacement="end"
                disabled={!generateBillet}
              />
            </Grid>
          )}
          {issueNfse && (
            <Grid item style={{ marginLeft: 30 }} container xs={11}>
              <FormControlLabel
                control={
                  <Switch
                    checked={valueInNote}
                    onChange={() => setValueInNote((current) => !current)}
                    color="secondary"
                  />
                }
                label="Emitir Nota das Despesas Reembolsáveis"
                labelPlacement="end"
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={generateFinancialStatement}
                  onChange={() =>
                    setGenerateFinancialStatement((current) => !current)
                  }
                  color="primary"
                />
              }
              label="Gerar Demonstrativo Financeiro"
              labelPlacement="end"
            />
          </Grid>
          <Grid item xs>
            <FormControlLabel
              control={
                <Switch
                  checked={sendByEmail}
                  onChange={() => setSendByEmail((current) => !current)}
                  color="secondary"
                />
              }
              label="Enviar por email"
              labelPlacement="end"
            />
          </Grid>
          {sendByEmail && (
            <>
              {generateBillet && (
                <Grid item style={{ marginLeft: 30 }} container xs={11}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={attachBillet}
                        onChange={() => setAttachBillet((current) => !current)}
                        color="secondary"
                      />
                    }
                    label="Anexar Boleto"
                    labelPlacement="end"
                  />
                </Grid>
              )}
              {issueNfse && (
                <Grid item style={{ marginLeft: 30 }} container xs={11}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={attachNfse}
                        onChange={() => setAttachNfse((current) => !current)}
                        color="secondary"
                      />
                    }
                    label="Anexar Nota Fiscal Serviço (NFSe)"
                    labelPlacement="end"
                  />
                </Grid>
              )}
              {generateFinancialStatement && (
                <Grid item style={{ marginLeft: 30 }} container xs={11}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={attachFinancialStatement}
                        onChange={() =>
                          setAttachFinancialStatement((current) => !current)
                        }
                        color="secondary"
                      />
                    }
                    label="Anexar Demonstrativo Financeiro"
                    labelPlacement="end"
                  />
                </Grid>
              )}
            </>
          )}
          <Grid item container xs={12} spacing={1}>
            <Grid item xs={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={applyBillingRule}
                    onChange={({ target: { checked } }) => {
                      setApplyBillingRule((current) => !current);
                      if (!checked) {
                        setBillingRule(null);
                      }
                    }}
                    color="secondary"
                  />
                }
                label="Régua de cobrança"
                labelPlacement="end"
              />
            </Grid>
            <Grid item xs>
              {applyBillingRule && (
                <SelectErp
                  label="Régua de Cobrança"
                  value={billingRule}
                  setValue={setBillingRule}
                  optionsList={listBillingRules}
                  descriptionField="label"
                  error={!!errorsSubmit?.billingRule}
                  helperText={errorsSubmit?.billingRule || ""}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Fieldset>
    </>
  );
};

export default AccordionInfoFaturamento;
